import React, { useEffect, useRef, useState } from 'react';
import M_PER_BASIC_01 from './M_PER_BASIC_01';
import Commons from '../../../../Services/Common/Common';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import Global from '../../../../Services/Common/Global';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import useFcmHandler from '../../../../Hooks/useFcmHandler';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useBackStack } from '../../../../Hooks/back/useBackStack';

const NOW = dayjs().format('YYYY-MM-DD HH:mm:ss');

export default function M_PER_BASIC_01F() {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const activeStep = useSelector((state) => state.common.activeStep);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { id } = useParams(); // 작업허가서 수정할 때 param으로 받아서 PM_CD 받아옴
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [codeList, setCodeList] = useState([]);
  const [rowData1, setRowData1] = useState([]); // 같은 부서 유저 데이터
  const [rowData2, setRowData2] = useState([]); // 반려 시 기본 정보
  const [rowData3, setRowData3] = useState([]); // 반려 시 체크리스트
  const [selectedDepHeadId, setSelectedDepHeadId] = useState('');
  const sendFcm = useFcmHandler();
  const [errors, setErrors] = useState({});
  const [inputBaseInfo, setInputBaseInfo] = useState({
    PM_CD: '', //코드
    CONSTRUCTION_NM: '', //공사업체명
    SITE_MANAGER: '', // 현장책임자
    SITE_PHONE: '', //전화번호
    WORK_START_DATE: '', //작업일시(시작)
    WORK_END_DATE: '', // 작업일시(끝)
    WORK_DETAIL: '', //작업내용
    WORK_PLACE: '', //작업장소
    WORK_MEMBER_NO: '', //작업인원수
    WORK_TYPE: [], //작업종류 (다중 선택)
  });
  const pmCdRef = useRef('');
  const activeStepRef = useRef(activeStep);

  useEffect(() => {
    activeStepRef.current = activeStep;
  }, [activeStep]);

  //  모바일 userInfo는 없는 데이터가 있어 다른 프로시저 이용해서 유저 정보 받아옴
  //  주의: IndexedDb에 있는 id는 암호화된 값이므로 프로시저 넘길 때 이 점 유의해서 사용할 것
  const Init = async () => {
    // 스택형 뒤로가기로 변경: write 진입 직후 step을 먼저 맞춤
    dispatch(CommonActions.setActiveStep(1));
    await SearchCode();
  };

  useEffect(() => {
    if (id && userInfo?.userid) {
      SearchLogic3();
    }
  }, [id, userInfo]);

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    if (rowData2 && Object.keys(rowData2).length > 0) {
      setInputBaseInfo((prev) => {
        const newData = {
          ...prev,
          ...Object.fromEntries(
            Object.entries(rowData2)
              .filter(([key]) => key in prev)
              .map(([k, v]) => [
                k,
                v !== null && v !== undefined ? String(v) : '',
              ])
          ),
        };

        // ✅ WORK_TYPE이 문자열이면 배열로 변환
        if (typeof newData.WORK_TYPE === 'string') {
          newData.WORK_TYPE = [newData.WORK_TYPE];
        }

        return newData;
      });
    }
  }, [rowData2]);

  // 스택형 뒤로가기로 변경: 첫 단계에서는 이탈 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: activeStep === 1 && !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClick' })),
  });

  // 스택형 뒤로가기로 변경: 다음 단계에서는 이전 단계로 복귀
  useBackStack({
    type: 'step',
    enabled: activeStep > 1 && activeStep < 4,
    onBack: () =>
      dispatch(CommonActions.setActiveStep(activeStepRef.current - 1)),
  });

  // 같은 부서 사람 조회
  const SearchLogic2 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_GET_DEP_MANAGER',
            _DEP_CD: Commons.EncryptAES(userInfo.depCd) || '',
            _USER_ID: userInfo.userid || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (Array.isArray(data) && data.length > 0) {
          setRowData1(data);
        }
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  // 작업허가서 상세 조회 수정할 때 필요함
  const SearchLogic3 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_PERMIT_R2',
            _PM_CD: Commons.EncryptAES(id),
            _USER_ID: userInfo.userid,
            _AUTH_CD: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length === 0) {
          setRowData2(null);
          setRowData3([]);

          dispatch(
            showSnackbar({ message: '데이터가 없습니다.', type: 'info' })
          );
        } else if (data[0]?.type === 'Error') {
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
          return false;
        } else {
          const baseInfo = { ...data[0] };

          const workTypeArr = [
            ...new Set(data.map((item) => item.WORK_TYPE)),
          ].filter(Boolean);

          baseInfo.WORK_TYPE = workTypeArr;

          setRowData2(baseInfo);

          const checklist = data.map((item) => ({
            PMD_CD: item.PMD_CD,
            WORK_TYPE_DTL: item.WORK_TYPE_DTL,
            WORK_TYPE_DTL_NM: item.WORK_TYPE_DTL_NM,
            ITEM_CHECK: item.ITEM_CHECK,
          }));
          setRowData3(checklist);
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  //코드정보 조회
  const SearchCode = async () => {
    try {
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [{ procedureName: 'SP_GetCode' }]
      );

      const data = result.data;

      if (!data || data.length === 0) return setCodeList([]);
      if (data[0]?.type === 'Error') throw new Error(data[0].message);

      const workTypes = data.filter((item) => item.groupCd === 'WORK_TYPE');
      const checkLists = data.filter((item) => item.groupCd.startsWith('WT_'));

      const groupedCheckLists = {};
      checkLists.forEach((item) => {
        const workTypeCode = item.groupCd;
        if (!groupedCheckLists[workTypeCode]) {
          groupedCheckLists[workTypeCode] = [];
        }
        groupedCheckLists[workTypeCode].push(item);
      });

      setCodeList({ workTypes, groupedCheckLists });
    } catch (e) {
      console.error(e);
    }
  };

  // 기본정보저장로직
  const SaveLogic1 = async () => {
    try {
      setLoading(true);
      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_PERMIT_U1',
            _PM_CD: Commons.EncryptAES(inputBaseInfo.PM_CD),
            _CUST_CD: Commons.EncryptAES(userInfo.custCd),
            _DEP_CD: Commons.EncryptAES(userInfo.depCd),
            _USER_ID: userInfo.userid,
            _CONSTRUCTION_NM: Commons.EncryptAES(inputBaseInfo.CONSTRUCTION_NM),
            _SITE_MANAGER: Commons.EncryptAES(inputBaseInfo.SITE_MANAGER),
            _SITE_PHONE: Commons.EncryptAES(inputBaseInfo.SITE_PHONE),
            _WORK_START_DATE: Commons.EncryptAES(
              inputBaseInfo.WORK_START_DATE || NOW
            ),
            _WORK_END_DATE: Commons.EncryptAES(
              inputBaseInfo.WORK_END_DATE || NOW
            ),
            _WORK_DETAIL: Commons.EncryptAES(inputBaseInfo.WORK_DETAIL),
            _WORK_PLACE: Commons.EncryptAES(inputBaseInfo.WORK_PLACE),
            _WORK_MEMBER_NO: Commons.EncryptAES(inputBaseInfo.WORK_MEMBER_NO),
            _DEP_HEAD_ID: Commons.EncryptAES(selectedDepHeadId),
          },
        ]
      );

      if (result.data[0]?.type === 'Error') {
        console.error(result.data[0]?.message);
        return;
      }

      const { PM_CD } = result.data[0];

      pmCdRef.current = PM_CD;
      setInputBaseInfo((prev) => ({
        ...prev,
        PM_CD: PM_CD,
      }));
      return PM_CD;
    } catch (error) {
      console.error(error);
      dispatch(showSnackbar({ message: '다시 시도해주세요.', type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  // 작업 항목별 체크리스트 저장
  const SaveLogic2 = async (item) => {
    try {
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_PERMIT_U2',
            _PMD_CD: Commons.EncryptAES(item.PMD_CD || ''),
            _PM_CD: Commons.EncryptAES(item.PM_CD),
            _WORK_TYPE: Commons.EncryptAES(item.workType),
            _WORK_TYPE_DTL: Commons.EncryptAES(item.code),
            _ITEM_CHECK: Commons.EncryptAES(item.check.toString()),
            _USER_ID: userInfo.userid,
          },
        ]
      );

      if (result.data[0]?.type === 'Error') {
        console.error(result.data[0]?.message);
        return;
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 작업종류가 바뀌면 항목별 작업 체크리스트 삭제 후 진행
  const prevWorkType = useRef(null);

  useEffect(() => {
    if (id && rowData2?.WORK_TYPE && prevWorkType.current === null) {
      prevWorkType.current = rowData2.WORK_TYPE;
    }
  }, [id, rowData2]);

  useEffect(() => {
    if (!id) return;
    if (prevWorkType.current === null) return;

    if (
      JSON.stringify(prevWorkType.current) !==
      JSON.stringify(inputBaseInfo.WORK_TYPE)
    ) {
      Commons.Axios('post', Global.base.useUrl + Global.urls.Execute.execute, [
        {
          procedureName: 'SP_PERMIT_D1',
          _PM_CD: Commons.EncryptAES(
            id || inputBaseInfo.PM_CD || pmCdRef.current
          ),
        },
      ]).then(() => {
        setRowData3([]);
      });
    }

    prevWorkType.current = inputBaseInfo.WORK_TYPE;
  }, [id, inputBaseInfo.WORK_TYPE]);

  // fcm
  const handleSignRequest = async () => {
    await sendFcm({
      targetUserId: selectedDepHeadId,
      requestUserId: userInfo.userid,
      body: '작업 허가서 요청입니다.',
      status: '요청',
      codeGroup: 'AL_002_001',
      title: '작업허가서',
      route: '/M_Permit',
      responseData: id || inputBaseInfo.PM_CD || pmCdRef.current,
    });
  };

  // 유효성 검사
  const ValidateField = (name, value) => {
    switch (name) {
      case 'CONSTRUCTION_NM':
        return value.trim() === '' ? '공사 업체명을 입력하세요.' : '';
      case 'SITE_MANAGER':
        return value.trim() === '' ? '현장 책임자를 입력하세요.' : '';
      case 'SITE_PHONE':
        return value.trim() === '' ? '연락처를 입력하세요.' : '';
      case 'WORK_START_DATE':
        return value.trim() === '' ? '작업 시작일시를 입력하세요.' : '';
      case 'WORK_END_DATE':
        return value.trim() === '' ? '작업 종료일시를 입력하세요.' : '';
      case 'WORK_DETAIL':
        return value.trim() === '' ? '작업 내용을 입력하세요.' : '';
      case 'WORK_PLACE':
        return value.trim() === '' ? '작업 장소를 입력하세요.' : '';
      case 'WORK_MEMBER_NO':
        return value.trim() === '' ? '작업 인원수를 입력하세요.' : '';
      default:
        return '';
    }
  };

  const ValidateAll = () => {
    const requiredFields = [
      'CONSTRUCTION_NM',
      'SITE_MANAGER',
      'SITE_PHONE',
      'WORK_START_DATE',
      'WORK_END_DATE',
      'WORK_DETAIL',
      'WORK_PLACE',
      'WORK_MEMBER_NO',
    ];

    let newErrors = {};
    let hasError = false;

    requiredFields.forEach((field) => {
      const msg = ValidateField(field, inputBaseInfo[field] || '');
      newErrors[field] = msg;
      if (msg) hasError = true;
    });

    setErrors(newErrors);
    return !hasError;
  };

  const handleChange = (name, value) => {
    setInputBaseInfo((prev) => {
      const updated = { ...prev, [name]: value ?? '' };
      return updated;
    });

    setErrors((prev) => ({ ...prev, [name]: ValidateField(name, value) }));
  };

  return (
    <div className="wrap">
      <M_PER_BASIC_01
        id={id}
        userInfo={userInfo}
        inputBaseInfo={inputBaseInfo}
        setInputBaseInfo={setInputBaseInfo}
        activeStep={activeStep}
        codeList={codeList}
        rowData1={rowData1}
        selectedDepHeadId={selectedDepHeadId}
        setSelectedDepHeadId={setSelectedDepHeadId}
        rowData2={rowData2}
        rowData3={rowData3}
        errors={errors}
        codeListForCheckList={
          Array.isArray(inputBaseInfo.WORK_TYPE)
            ? inputBaseInfo.WORK_TYPE.reduce((acc, wt) => {
                acc[wt] = codeList?.groupedCheckLists?.[wt] || [];
                return acc;
              }, {})
            : {}
        }
        // 함수
        SearchLogic2={SearchLogic2}
        SaveLogic1={SaveLogic1}
        SaveLogic2={SaveLogic2}
        handleSignRequest={handleSignRequest}
        ValidateAll={ValidateAll}
        handleChange={handleChange}
      />
    </div>
  );
}
